import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

export default function ProtectedRoute() {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  
  console.log('[PROTECTED-ROUTE] Checking auth state');
  console.log('[PROTECTED-ROUTE] isAuthenticated:', isAuthenticated);
  console.log('[PROTECTED-ROUTE] loading:', loading);
  console.log('[PROTECTED-ROUTE] user:', user);

  if (loading) {
    console.log('[PROTECTED-ROUTE] Still loading, showing spinner');
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-950">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  console.log('[PROTECTED-ROUTE] Decision:', isAuthenticated ? 'Allow access' : 'Redirect to login');
  const returnPath = `${location.pathname}${location.search}${location.hash}`;
  return isAuthenticated
    ? <Outlet />
    : <Navigate to="/login" replace state={{ from: returnPath }} />;
}
